import type { ResponseGetMerchflow_merchflowId_StorePogTriggerAllFinished } from "@CommonApi/merchflow/_merchflowId_/store-pog-trigger/all-finished";
import { routeToUrl } from "@CommonUtils/routes";
import { Select } from "src/elements";
import { sortStorePogVersionsNewestFirst, storePogVersionLabel } from "src/utils/storePogVersions";
import { pages } from "src/utils";
import { useNavigation } from "src/utils/navigation";

interface Props {
  storePogTriggers: ResponseGetMerchflow_merchflowId_StorePogTriggerAllFinished | null | undefined;
  merchflowId: number;
  storePogTriggerId: number | undefined;
}

export const SelectStorePogTrigger = ({
  merchflowId,
  storePogTriggers,
  storePogTriggerId,
}: Props) => {
  const { navigate } = useNavigation();

  const isLoading = storePogTriggers === undefined;
  const storePogTriggerOptions = storePogTriggers
    ? sortStorePogVersionsNewestFirst(storePogTriggers).map((storePogTrigger) => ({
        label: storePogVersionLabel(storePogTrigger),
        value: storePogTrigger.store_pog_trigger_id,
      }))
    : [];

  const setStorePogTriggerId = (nextStorePogTriggerId: number | null) => {
    if (nextStorePogTriggerId === null) {
      navigate(
        routeToUrl(pages.merchflows_merchflowId_StoresAll, {
          merchflowId,
        }),
      );
    } else {
      navigate(
        routeToUrl(
          pages.merchflows_merchflowId_StoresAll,
          {
            merchflowId,
          },
          { store_pog_trigger_id: nextStorePogTriggerId },
        ),
      );
    }
  };

  return (
    <Select
      width="150px"
      title="Filter store POGs by"
      placeholder="Version"
      options={
        storePogTriggers ? [{ label: "Latest", value: null }, ...storePogTriggerOptions] : []
      }
      value={storePogTriggerId ?? null}
      setValue={setStorePogTriggerId}
      isLoading={isLoading}
    />
  );
};
